import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import itemTypePluralize from '../../common/itemTypePluralrize';
import { collectionsByType } from '../../../redux/selectors/collections';
import { collectionsGroupType, catSplitAttrsType } from '../../common/types';
import pageWrapper from '../../containers/MainPage';
import ItemPreview from '../../common/ItemPreview';
import slug from '../../../slugger';
import { changeCatSplit } from '../../../redux/ducks/collections';
import Loading from '../../common/Loading';
import { NotFound } from '../../NotFound';
import SliderGalleryItem from '../../../models/SliderGalleryItem';
import Breadcrumbs from '../../common/Breadcrumbs';
import AddItemButton from './AddItemButton';
import CollectionFilterSwitcher from './CollectionFilterSwitcher';

class SubCategoryPage extends React.PureComponent {
  componentDidMount() {
    // Compare URL-requested subcategoryType with what is in catSplitAttributes
    // If they do not match, issue a change action to sync them up.
    const {
      match: {
        params: { category, subcategoryType },
      },
      changeCatSplitAttr,
    } = this.props;

    if (!this.isCatSplitConsistent()) {
      changeCatSplitAttr(category, subcategoryType);
    }
  }

  isCatSplitConsistent = () => {
    const {
      catSplitAttributes,
      match: {
        params: { category, subcategoryType },
      },
    } = this.props;

    return catSplitAttributes[category] === subcategoryType;
  };

  render() {
    const { collections } = this.props;
    const {
      match: {
        params: { category, subcategoryType, subcategory },
      },
    } = this.props;

    // If URL-requested subcategoryType doesn't match what is in
    // catSplitAttributes, show Loading till the change updates.
    if (!this.isCatSplitConsistent()) {
      return <Loading />;
    }

    const subcat = _.find(collections[category], (value, key) => slug(key) === subcategory);
    if (!subcat) {
      return <NotFound />;
    }

    const subcatNiceName = subcat[0].specificData[subcategoryType];

    return (
      <div>
        <Breadcrumbs
          segments={[
            { label: 'Collections', linkTo: '/collections' },
            { label: itemTypePluralize(category), linkTo: `/collections/${category}` },
            {
              label: subcatNiceName,
            },
          ]}
        />

        <div className="level">
          <div className="level-left">
            <div className="level-item">
              <CollectionFilterSwitcher />
            </div>
          </div>
          <div className="level-right">
            <div className="level-item">
              <AddItemButton />
            </div>
          </div>
        </div>

        <h3 className="title is-4" style={{ marginBottom: 0 }}>
          {subcatNiceName === '' ? '(Unknown)' : subcatNiceName}
        </h3>
        {subcat.map(item => (
          <ItemPreview
            item={SliderGalleryItem.ItemFromGenericItemModel(
              item,
              category,
              subcategoryType,
              subcatNiceName
            )}
            key={item.id}
          />
        ))}
      </div>
    );
  }
}

SubCategoryPage.propTypes = {
  collections: collectionsGroupType,
  catSplitAttributes: catSplitAttrsType.isRequired,
  match: PropTypes.shape({
    shape: PropTypes.shape({
      category: PropTypes.string,
      subcategory: PropTypes.string,
      subcategoryType: PropTypes.string,
    }),
  }).isRequired,
  changeCatSplitAttr: PropTypes.func.isRequired,
};

SubCategoryPage.defaultProps = {
  collections: [],
};

function mapStateToProps(state) {
  const {
    collections: { catSplitAttributes },
  } = state;

  return {
    collections: collectionsByType(state),
    catSplitAttributes,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeCatSplitAttr: (category, newAttr) => {
      dispatch(changeCatSplit(category, newAttr));
    },
  };
}

export default pageWrapper(
  connect(mapStateToProps, mapDispatchToProps)(SubCategoryPage),
  'My Collection'
);



// WEBPACK FOOTER //
// ./src/components/pages/collections/SubCategoryPage.jsx